import * as React from "react";
import { UitkLayout } from "../uitk-react-layout/index.js";
import { classNames } from "../uitk-react-utils/index.js";
import {
  UitkLayoutFlexAlignContents,
  UitkLayoutFlexAlignItems,
  UitkLayoutFlexBlockSizes,
  UitkLayoutFlexDirections,
  UitkLayoutFlexJustifyContents,
  UitkLayoutFlexWraps
} from "./types.js";
export const UitkLayoutFlex = (props) => {
  const {
    alignContent,
    alignItems,
    blockSize,
    children,
    className,
    direction,
    justifyContent,
    space,
    gap,
    tag,
    wrap,
    dataTestId,
    style,
    ...attributes
  } = props;
  const baseClass = "uitk-layout-flex";
  const wrapperClassNames = classNames(
    baseClass,
    alignContent && `${baseClass}-${UitkLayoutFlexAlignContents.get(alignContent)}`,
    alignItems && `${baseClass}-${UitkLayoutFlexAlignItems.get(alignItems)}`,
    blockSize && `${baseClass}-${UitkLayoutFlexBlockSizes.get(blockSize)}`,
    direction && `${baseClass}-${UitkLayoutFlexDirections.get(direction)}`,
    justifyContent && `${baseClass}-${UitkLayoutFlexJustifyContents.get(justifyContent)}`,
    space && `${baseClass}-space-${space}`,
    gap && `${baseClass}-gap-${gap}`,
    wrap && `${baseClass}-${UitkLayoutFlexWraps.get(wrap)}`,
    className
  );
  return children ? /* @__PURE__ */ React.createElement(
    UitkLayout,
    {
      className: wrapperClassNames,
      tag,
      ...attributes,
      ...dataTestId && { "data-test-id": dataTestId },
      style
    },
    children
  ) : null;
};
UitkLayoutFlex.displayName = "UitkLayoutFlex";
